import { SafePromise, safeResilient } from '@benzinga/safe-await';
import { Session } from '@benzinga/session';
import { RestfulClient } from '@benzinga/session';
import { UserEnvironment } from './environment';

export class UserRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(UserEnvironment).url, session, { authorizationSession: true });
  }

  getUserSettings = (): SafePromise<Record<string, object>> => {
    const url = this.URL('api/v1/account/settings/');
    return this.get(url, { includeHeader: { 'x-session-key': true } });
  };

  setUserSetting = (key: string, value: object): SafePromise<undefined> => {
    const url = this.URL(`api/v1/account/settings/${key}/`);
    return safeResilient(this.post, { delayOffset: 8000, maxNumOfAttempts: 5 })(url, value, {
      includeHeader: {
        referer: url.toString(),
        'x-csrf-token': true,
        'x-session-key': true,
      },
    });
  };
}
